import $ from 'jquery';
import Vue from 'vue';
import Flickity from 'flickity';
import conditioner from 'offhand-conditioner';
import LoginCta from './LoginCta.vue';
import CartCount from './CartCount.vue';
import { isIndianaVisitor, applyWeightLossMarketingRestrictions } from './heroGeoRestriction';
import './heroCarousel.plugin';

window.$ = $;

Vue.component('v-login-cta', LoginCta);
Vue.component('v-cart-count', CartCount);

new Vue({
    el: '#site-container',
});

$(function() {
    function rafThrottle(fn) {
        let ticking = false;
        return function throttled() {
            if (ticking) return;
            ticking = true;
            window.requestAnimationFrame(() => {
                fn();
                ticking = false;
            });
        };
    }

    // --- Center section: video popup on block click ---
    $('.homeCenterWrapper__blocks__item__image').on('click', function() {
        let vidSrc = $(this).attr('data-video')
        if(vidSrc) {
            $('.siteOverlay').first().fadeIn()
            const $popup = $('.videoPopupWrapper').first()
            $popup.fadeIn().find('video').attr('src', vidSrc)
            $popup.find('video')[0].play()
        }
    })

    // --- Center section: faster playback on block videos ---
    const videoElementsNode = $('.homeCenterWrapper__blocks__item__image video');
    const videoElements = Array.from(videoElementsNode);
    videoElements.forEach(video => {
        video.playbackRate = 1.25;
    });

    const homeCenterElement = $('.homeCenterWrapper');
    const homeCenterItems = $('.homeCenterWrapper__blocks__item');
    const animatedTextEl = $('.text--animated');

    function homeCenterBlockInView(rect, vh) {
        const enterLine = vh * (window.innerWidth > 992 ? 0.9 : 0.92);
        const exitTop = Math.min(140, vh * 0.18);
        return rect.top < enterLine && rect.bottom > exitTop;
    }

    function updateHomeCenterBlocks() {
        if (!homeCenterItems.length) return;
        homeCenterItems.each(function() {
            const el = this;
            const rect = el.getBoundingClientRect();
            const vh = window.innerHeight || document.documentElement.clientHeight;
            const fullH = el.scrollHeight;
            if (homeCenterBlockInView(rect, vh)) {
                $(el).addClass('active').height(fullH);
            } else {
                $(el).removeClass('active').height(90);
            }
        });
    }

    function initHomeCenterAnimatedText() {
        if (!animatedTextEl.length || !homeCenterElement.length) return;
        const blocks = homeCenterElement.find('.homeCenterWrapper__blocks');
        const trigger =
          blocks.find('.homeCenterWrapper__blocks__item:nth-child(3)')[0] ||
          blocks.find('.homeCenterWrapper__blocks__item:last-child')[0] ||
          homeCenterElement[0];

        const reveal = function() {
            animatedTextEl.stop(true, true).fadeIn(350);
        };

        if (!trigger || window.matchMedia('(max-width: 992px)').matches) {
            return;
        }

        if (typeof IntersectionObserver !== 'undefined') {
            const io = new IntersectionObserver(
              function(entries) {
                  entries.forEach(function(entry) {
                      if (entry.isIntersecting) reveal();
                  });
              },
              { root: null, rootMargin: '0px 0px 0px 0px', threshold: 0.2 }
            );
            io.observe(trigger);
        } else {
            $(window).on('scroll', rafThrottle(function() {
                const r = trigger.getBoundingClientRect();
                const vh = window.innerHeight || document.documentElement.clientHeight;
                if (r.top < vh && r.bottom > 0) reveal();
            }));
        }
    }

    $(window).on('load', function() {
        if (homeCenterElement.length === 0) return;
        initHomeCenterAnimatedText();
        updateHomeCenterBlocks();
        $(window).on('scroll', rafThrottle(updateHomeCenterBlocks));
        $(window).on('resize', rafThrottle(updateHomeCenterBlocks));
    });

    // --- Video section: popup on click ---
    $('.videoSlider__carousel__item').on('click', function (evt) {
        let vidSrc = $(this).attr('data-src')
        if (!vidSrc) return
        $('.siteOverlay').first().fadeIn()
        const $popup = $('.videoPopupWrapper').first()
        $popup.fadeIn().find('video').attr('src', vidSrc)
        $popup.find('video')[0].play()
    })

    $('.videoPopupWrapper__close').on('click', function() {
        $('.videoPopupWrapper video').each(function () { this.pause(); $(this).attr('src', '') })
        $('.siteOverlay').fadeOut()
        $('.videoPopupWrapper').fadeOut()
    })

    // --- Form group label animations ---
    $('.form-group input').on('focusin', function (e) {
        $(this).parents('.form-group').addClass('active')
    })
    $('.form-group input').on('focusout', function (e) {
        if (!this.value) {
            $(this).parents('.form-group').removeClass('active')
        }
    })

    conditioner('body');

    // --- Sticky header ---
    const headerTarget = $('header.home');
    const toggleHomeHeaderFixed = function() {
        if ($(window).scrollTop() > 100) {
            headerTarget.addClass('header-fixed');
        } else {
            headerTarget.removeClass('header-fixed');
        }
    };

    toggleHomeHeaderFixed();

    $(window).on('scroll', rafThrottle(toggleHomeHeaderFixed));

    // --- Main navigation ---
    var navIcon         = $('.nav-icon'),
      navContainer    = $('.menu'),
      navPrimary      = $('nav.primary');

    navIcon.on('click', function() {
        navContainer.toggleClass('menu-active');
        navIcon.toggleClass('nav-icon--active');
        navPrimary.toggleClass('nav-active');
    });

    var hasDropdown = $('.has-dropdown > a');

    hasDropdown.on('click', function(e) {
        if ($(window).width() < 960) {
            e.preventDefault();
        }
        var $parentLi = $(this).closest('li');
        $parentLi.toggleClass('has-dropdown--active');
        $parentLi.find('.dropdown-menu').toggleClass('dropdown-menu--active');
    });

    // --- State-based UI restrictions (e.g. Indiana) ---
    function applyStateUI(nextState) {
        const state = (nextState || localStorage.getItem('state') || '').trim().toLowerCase();
        const url = window.location.pathname.toLowerCase();

        if (
          state === 'indiana' &&
          url.includes('semaglutide-and-tirzepatide')
        ) {
            window.location.href = '/';
        }

        if (state === 'indiana') {
            document.querySelectorAll('.hero-navigation-item').forEach(item => {
                const title = item.dataset.title;

                if (title.includes('weight')) {
                    item.style.display = 'none';
                }
            });
        }
    }

    applyStateUI();
    applyWeightLossMarketingRestrictions();

    fetch('/api/geo')
        .then(function(res) {
            if (!res.ok) {
                throw new Error('Failed geolocation request');
            }
            return res.json();
        })
        .then(function(data) {
            var state = (data.region || '').trim();
            if (state) {
                localStorage.setItem('state', state);
            }
            var regionCode = (data.region_code || '').trim();
            if (regionCode) {
                localStorage.setItem('stateCode', regionCode);
            }
            var countryCode = (data.country_code || '').trim();
            if (countryCode) {
                localStorage.setItem('countryCode', countryCode);
            }
            return state;
        })
        .then(function(state) {
            applyStateUI(state);
            applyWeightLossMarketingRestrictions();
        })
        .catch(function() {
            applyStateUI();
            applyWeightLossMarketingRestrictions();
        });
});

// --- Video slider (Flickity) + redactor scroll animations ---
(function() {
    const videoSlider = document.querySelector('.videoSlider__carousel')
    let videoSliderFlickity = null;
    let flickityBound = false;

    function debounce(fn, wait) {
        let timeout = null;
        return function debounced() {
            clearTimeout(timeout);
            timeout = setTimeout(fn, wait);
        };
    }

    function initializeFlickity() {
        if (!videoSliderFlickity) {
            videoSliderFlickity = new Flickity(videoSlider, {
                contain: true,
                cellAlign: 'center',
                percentPosition: false,
                selectedAttraction: 0.005,
                freeScroll: false,
                arrowShape: 'M100,43.8H23.9L58.9,8.8L50,0L0,50l50,50l8.8-8.8L23.9,56.2H100V43.8z',
                draggable: true,
            });
        } else {
            videoSliderFlickity.resize();
            return;
        }

        let isDragging = false;
        const dragStart = (e) => {
            if (isDragging) return;
            videoSliderFlickity.slider.childNodes.forEach(slide => slide.style.pointerEvents = "none")
            isDragging = true;
        }

        const dragEnd = (e) => {
            if (!isDragging) return;
            videoSliderFlickity.slider.childNodes.forEach(slide => slide.style.pointerEvents = "all")
            isDragging = false
        }

        if (!flickityBound) {
            videoSliderFlickity.slider.addEventListener('touchmove', dragStart);
            videoSliderFlickity.slider.addEventListener('touchend', dragEnd);
            videoSliderFlickity.on('dragStart', dragStart);
            videoSliderFlickity.on('dragEnd', dragEnd);
            flickityBound = true;
        }
    }

    document.addEventListener('DOMContentLoaded', function () {
        $('.form-group input').each(function() {
            if (!this.value) {
                $(this).parents('.form-group').removeClass('active')
            }else {
                $(this).parents('.form-group').addClass('active')
            }
        })
        if(videoSlider) {
            initializeFlickity()
        }
    });

    window.addEventListener('resize', debounce(function() {
        if(videoSlider) {
            initializeFlickity()
        }
    }, 150));

    const elements = document.querySelectorAll('.redactor-circle, .redactor-underline');
    function isInViewport(element, offset = 0) {
        const rect = element.getBoundingClientRect();
        return (
          rect.top + offset >= 0 &&
          rect.left + offset >= 0 &&
          rect.bottom + offset <= (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right + offset <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    function addActiveClass() {
        window.requestAnimationFrame(() => {
            let delay = 500
            let visibleEls = Array.from(elements).filter(el => !el.classList.contains('visible') && isInViewport(el, 150));
            for(let i = 0; i < visibleEls.length; i++) {
                let newDelay = delay + i * 500
                setTimeout(() => {
                    visibleEls[i].classList.add(`visible`);
                }, newDelay)
            }
        });
    }
    addActiveClass();
    window.addEventListener('scroll', debounce(addActiveClass, 120));
})();

// --- Companies mobile slider (Flickity) ---
(function() {
    if (window.innerWidth >= 768) return;

    const companySlider = document.querySelector('.companies-mobile');
    if (!companySlider) return;

    document.addEventListener('DOMContentLoaded', function () {
        new Flickity(companySlider, {
            cellAlign: 'left',
            contain: true,
            autoPlay: 4000,
            prevNextButtons: false,
            pageDots: false,
            pauseAutoPlayOnHover: false,
            draggable: true,
            wrapAround: true,
            on: {
                ready: function() {
                    document.querySelector('.companies-wrapper').style.display = 'none'
                    document.querySelector('.companies-wrapper-mobile').style.opacity = 1
                }
            }
        });
    });
})();



// WEBPACK FOOTER //
// ./resources/assets/js/landing.js